import { render, staticRenderFns } from "./CompanyAddModule.vue?vue&type=template&id=01c61ff8&scoped=true"
import script from "./CompanyAddModule.vue?vue&type=script&lang=js"
export * from "./CompanyAddModule.vue?vue&type=script&lang=js"
import style0 from "./CompanyAddModule.vue?vue&type=style&index=0&id=01c61ff8&prod&scoped=true&lang=scss"
import style1 from "./CompanyAddModule.vue?vue&type=style&index=1&id=01c61ff8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c61ff8",
  null
  
)

export default component.exports